export default __webpack_public_path__ + "static/media/img--design-8.a1e05899.jpg";